import store from '@/store';

// 检验按钮权限
const checkBtnPermission = btnPermission => {
  let allBtnPermission = store.getters.buttons;
  let boolean = false;

  let authFromLocal = store.getters.authFromLocal;
  // 本地开发-放开所有权限
  if (authFromLocal) {
    boolean = true;
  } else {
    boolean = allBtnPermission.includes(btnPermission);
  }

  return boolean;
};

export default checkBtnPermission;
